import { useContext, useEffect, useState } from 'react';
import {
    Divider,
    Typography,
} from 'antd';
import {
    LoadingOutlined,
} from '@ant-design/icons';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table/Table';
import { useStudentViewData } from '../../utils/useStudentViewData';
import { BreadCrumbContext } from '../index';
import ScoreViewOption, { INIT_FILTER_OPTIONS } from '../common/ScoreViewOption';
import { BaseTable } from 'components/modules/BaseTable';
import { createColumns } from './createColumns';

// antd の Tree data の表示を使うための型
type DataSource = AppStatusModal.StudentView['applications'][number];

export const StudentView : React.FC = () => {
    const { breadcrumb, setBreadcrumb } = useContext(BreadCrumbContext);
    const [studentView] = useStudentViewData({ name: breadcrumb.name ?? '', uuid: breadcrumb.uuid });
    const [filterOptions, setFilterOptions] = useState<string[]>(INIT_FILTER_OPTIONS);
    const [expandedRowKeys, setExpandedRowKeys] = useState<ReadonlyArray<string>>([]);
    const [filterLoading, setFilterLoading] = useState(false);

    const [pagination, setPagination] = useState<TablePaginationConfig>({
        ...studentView.pagination,
        showTotal: (total, range) => {
            return (`全${total}件中 ${range[0]}-${range[1]} 件`);
        },
        onChange: (page, pageSize) => {
            setPagination(pagination => ({
                ...pagination,
                current: page,
                pageSize,
            }));
        }
    });

    const handleClickTestInfo = (name: string, uuid: string) => {
        setBreadcrumb({ name: name, uuid: uuid, type: 'Application' });
    };

    const handleShowHistory = (breadcrumb: AppStatusModal.Breadcrumb, uuid: string) => {
        setBreadcrumb({ uuid: uuid, type: 'History' , history: breadcrumb});
    }

    const handleChangeViewOption = (value: string) => {
        setFilterLoading(true);
        setFilterOptions((prev) => {
            if (prev?.length > 0 && prev?.includes(value)) {
                return [...prev.filter((item) => item !== value)];
            }
            return [...prev, value];
        });
    };

    useEffect(() => {
        setFilterLoading(false);
    }, [filterLoading])

    useEffect(()=> {
        setExpandedRowKeys(studentView.applications?.flatMap(app => 
            [app.uuid, ...app.children?.map(child => child && child?.uuid) || []]
          ));
    }, [studentView]);

    const columnsTest: ColumnsType<DataSource> = createColumns(
        handleClickTestInfo,
        handleShowHistory,
        filterOptions,
        breadcrumb
    );

    return (
        <div>
            <Typography.Title level={3}>
                {`${studentView.student.name} さんの学習結果`}
            </Typography.Title>
            <Divider style={{ marginTop: '0.5rem', marginBottom: '2rem' }} />
            <ScoreViewOption onChange={handleChangeViewOption} />

            <BaseTable
                emptyDescription={''} // 通常空になることはない
                rowKey='uuid'
                key='resourceTable'
                columns={columnsTest}
                dataSource={[...studentView.applications]}
                pagination={pagination}
                loading={{
                    spinning: studentView.loading || filterLoading,
                    indicator: <LoadingOutlined style={{ fontSize: '35px' }} />,
                }}
                expandable={{ 
                    indentSize: 100,
                    expandedRowKeys,
                    expandIcon: () => <></>,
                }}
                tableLayout='auto'
                scroll={{ x: 'max-content' }}
                showTopScroll={true}
            />
        </div>
    );
};
